import axios from 'axios';

const API_BASE_URL = 'https://backend.gouniquejourneys.co.uk/api/employee/invoice'; // Replace with actual backend URL

export const sendFlightInvoice = async (customerEmail, booking) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/send-flight-invoice`,
      {
        customerEmail,
        booking,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );

    console.log('Flight Invoice Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error sending flight invoice:', error.response?.data || error.message);
    throw error;
  }
};

export const sendHotelInvoice = async (customerEmail, booking) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/send-hotel-invoice`,
      {
        customerEmail,
        booking,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );

    console.log('Hotel Invoice Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error sending hotel invoice:', error.response?.data || error.message);
    throw error;
  }
};

export const sendTourInvoice = async (customerEmail, booking) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/send-tour-invoice`,
      {
        customerEmail,
        booking,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );

    console.log('Tour Invoice Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error sending tour invoice:', error.response?.data || error.message);
    throw error;
  }
};
